import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function RgpdConsentBanner() {
  const { user, setUser } = useAuth();
  const [saving, setSaving] = useState(false);
  if (!user || user.consent_rgpd_at || user.is_demo || user.role === "demo") return null;
  if (!["agent", "gardiennage", "manager", "chef_poste"].includes(user.role)) return null;

  const accept = async () => {
    setSaving(true);
    try {
      const { data } = await api.post("/auth/accept-rgpd");
      setUser(data);
      toast.success("Merci — votre consentement a été enregistré.");
    } catch { toast.error("Impossible d'enregistrer le consentement. Réessayez."); }
    finally { setSaving(false); }
  };

  return (
    <div className="px-6 sm:px-8 pt-4" data-testid="rgpd-consent-banner">
      <div className="rounded-lg border border-[#007AFF]/40 bg-[#007AFF]/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <ShieldCheck className="w-5 h-5 text-[#4da3ff] shrink-0" />
        <p className="text-sm text-zinc-200 flex-1">
          Merci de confirmer votre acceptation de la{" "}
          <a href="/confidentialite" target="_blank" rel="noopener noreferrer" className="text-[#4da3ff] hover:underline">politique de confidentialité</a>{" "}
          (RGPD) pour finaliser votre dossier.
        </p>
        <Button onClick={accept} disabled={saving} data-testid="rgpd-accept-button" className="bg-[#007AFF] hover:bg-[#3395FF] text-white shrink-0">
          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ShieldCheck className="w-4 h-4 mr-2" />} J'accepte
        </Button>
      </div>
    </div>
  );
}
